"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var icons_1 = require("../icons");
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var hooks_1 = require("../utils/hooks");
var input_1 = require("./input");
function TextInput(_a) {
    var valueFromProps = _a.value, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, onChange = _a.onChange, placeholder = _a.placeholder, _c = _a.disabled, disabled = _c === void 0 ? false : _c, size = _a.size, validateStatus = _a.validateStatus, _d = _a.clearable, clearable = _d === void 0 ? false : _d, prefix = _a.prefix, suffix = _a.suffix, inputRefFromProps = _a.inputRef, inputProps = _a.inputProps, otherProps = tslib_1.__rest(_a, ["value", "defaultValue", "onChange", "placeholder", "disabled", "size", "validateStatus", "clearable", "prefix", "suffix", "inputRef", "inputProps"]);
    var inputClassName = ConfigProvider_1.usePrefix('text-input');
    var _e = hooks_1.useFocused(inputProps), focused = _e.focused, focusedHandlers = _e.focusedHandlers;
    var innerInputRef = react_1.useRef(null);
    var inputRef = hooks_1.useRefs(inputRefFromProps, innerInputRef);
    var _f = hooks_1.useValue({ valueFromProps: valueFromProps, defaultValue: defaultValue, onChange: onChange }), value = _f.value, setValue = _f.setValue;
    var inputStyleClassName = input_1.useInputStyle({
        focused: focused,
        validateStatus: validateStatus,
        size: size,
        disabled: disabled
    });
    var className = classnames_1.default(inputStyleClassName, inputClassName, otherProps.className);
    var prefixView = prefix != null && (react_1.default.createElement("div", { className: utils_1.concat(inputClassName, 'prefix') }, prefix));
    var handleClear = react_1.useCallback(function () {
        var _a;
        setValue('');
        (_a = innerInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [setValue]);
    var clearText = ConfigProvider_1.useLangData('textInput').clearText;
    var clearIconView = clearable && value && (react_1.default.createElement("button", { type: "button", title: clearText, className: utils_1.concat(inputClassName, 'clear'), onClick: handleClear },
        react_1.default.createElement(icons_1.CloseCircleIcon, null)));
    var hasSuffix = suffix != null || clearIconView;
    var suffixView = hasSuffix && (react_1.default.createElement("div", { className: utils_1.concat(inputClassName, 'suffix') },
        clearIconView,
        suffix));
    var handleChange = react_1.useCallback(function (e) {
        var _a;
        (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange) === null || _a === void 0 ? void 0 : _a.call(inputProps, e);
        setValue(e.target.value);
    }, [inputProps, setValue]);
    var handleWrapperClick = react_1.useCallback(function () {
        var _a;
        (_a = innerInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (react_1.default.createElement("div", tslib_1.__assign({}, otherProps, { className: className, onClick: handleWrapperClick }),
        prefixView,
        react_1.default.createElement("input", tslib_1.__assign({}, inputProps, focusedHandlers, { ref: inputRef, className: classnames_1.default(utils_1.concat(inputClassName, 'inner'), inputProps === null || inputProps === void 0 ? void 0 : inputProps.className), disabled: disabled, value: value, placeholder: placeholder, onChange: handleChange })),
        suffixView));
}
exports.default = TextInput;
//# sourceMappingURL=TextInput.js.map